// src/ThemeProvider.js
import React, { createContext, useState, useEffect } from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import lightTheme from './LightTheme';
import darkTheme from './DarkTheme';
import { muiLightTheme, muiDarkTheme } from './MuiTheme';

const ThemeContext = createContext({
    theme: 'light',
    toggleTheme: () => {},
});

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState(() => {
        const savedTheme = localStorage.getItem('theme');
        return savedTheme || 'light';
    });

    const currentTheme = theme === 'light' ? lightTheme : darkTheme;
    const muiTheme = theme === 'light' ? muiLightTheme : muiDarkTheme;

    useEffect(() => {
        localStorage.setItem('theme', theme);
        document.body.style.backgroundColor = currentTheme.colors.backgroundSecondary;
    }, [theme, currentTheme]);

    const toggleTheme = () => {
        setTheme(prevTheme => (prevTheme === 'light' ? 'dark' : 'light'));
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            <MuiThemeProvider theme={muiTheme}>
                <StyledThemeProvider theme={currentTheme}>
                    <CssBaseline />
                    {children}
                </StyledThemeProvider>
            </MuiThemeProvider>
        </ThemeContext.Provider>
    );
};

export const useTheme = () => React.useContext(ThemeContext);
